import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalSavingAccontImage from "../../assets/static/personal/profile_settings.png";

function IndividualAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Individual Account? We’ve got you covered."
        description="Kontriman provides several ways to assist you with your Individual account – through our help center, chat support, and email. Access the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Individual Account</h1>
                  <p>
                    Our Individual Account offers a reliable and flexible
                    banking solution tailored for personal financial needs.
                    Whether you're managing daily expenses or planning your
                    financial future, this account gives you control and
                    convenience.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>
                      Easy account management with online and mobile banking
                    </li>
                    <li>Access to ATM and debit card services</li>
                    <li>No hidden charges or maintenance fees</li>
                    <li>Secure and quick fund transfers</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Valid national ID or passport</li>
                    <li>Proof of address</li>
                    <li>Minimum age: 18 years</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Individual Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={personalSavingAccontImage}
                  alt="Individual Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default IndividualAccount;
